import { BaseSyntheticEvent, useState } from 'react';
import axios from 'axios';
import './UserProfile.scss';
import { Button, Card, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AuthHeader } from '../../../utils/helpers/auth-headers';
import { AlertSeverity } from '../../../utils/enum/Alerts';
import { setAlertData } from '../../../stores/alertStore';

interface UpdatePassword {
  password: string;
}

function UserEditPassword() {
  const { t } = useTranslation();

  const initError = {
    passwordError: false,
    passwordHelper: '',
    confirmPasswordError: false,
    confirmPasswordHelper: ''
  };
  const [hasError, setHasError] = useState(initError);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [updatePassword, setUpdatePassword] = useState({
    password: '',
    confirmPassword: ''
  });

  const handleChange = (event: any) => {
    setUpdatePassword({ ...updatePassword, [event.target.name]: event.target.value });
  };

  const updateProfile = () => {
    const modifyPassword: UpdatePassword = {
      password: updatePassword.password
    };
    axios.post(`${window._env_.REACT_APP_API_URI}/user/password`, modifyPassword, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} })
      .then(() => {
        setUpdatePassword({
          password: '',
          confirmPassword: ''
        });
        dispatch(setAlertData({
          message: t('UserProfile.updateSuccess'),
          severity: AlertSeverity.SUCCESS,
          open: true,
        }));
        navigate('/profile');
      })
      .catch((error) => {
        if (error.response) {
          const err = error.response;
          console.error(err);
          dispatch(setAlertData({
            message: err.data.message,
            severity: AlertSeverity.ERROR,
            open: true,
          }));
        }
        console.error(error);
      });
  };

  const onUpdateProfile = (event: BaseSyntheticEvent) => {
    event.preventDefault();
    const tempError = { ...initError };
    if (updatePassword.password === '') {
      tempError.passwordError = true;
      tempError.passwordHelper = 'UserProfile.passwordRequired';
    }
    if (updatePassword.password.length < 6) {
      tempError.passwordError = true;
      tempError.passwordHelper = 'UserProfile.passwordTooShort';
    }
    if (updatePassword.confirmPassword === '') {
      tempError.confirmPasswordError = true;
      tempError.confirmPasswordHelper = 'UserProfile.confirmPasswordRequired';
    }
    if (updatePassword.confirmPassword.length < 6) {
      tempError.confirmPasswordError = true;
      tempError.confirmPasswordHelper = 'UserProfile.confirmPasswordTooShort';
    }
    if (updatePassword.password !== updatePassword.confirmPassword) {
      tempError.confirmPasswordError = true;
      tempError.confirmPasswordHelper = 'UserProfile.noMatch';
    }
    setHasError(tempError);
    if (_.isEqual(tempError, initError)) {
      updateProfile();
    }
  };

  return (
    <Card sx={{ marginBottom: '30px' }}>
      <div className="card-title">
        <FontAwesomeIcon className="title-icon" icon={faEdit} />&nbsp;
        {t('UserProfile.updateMyPassword')}
      </div>
      <div>
        <form onSubmit={onUpdateProfile} className="form">
          <TextField
            variant="outlined"
            label={t('UserProfile.password')}
            error={hasError.passwordError}
            helperText={hasError.passwordError ? t(hasError.passwordHelper) : ''}
            value={updatePassword.password}
            onChange={handleChange}
            type="password"
            name="password"
            required
          />
          <TextField
            variant="outlined"
            label={t('UserProfile.confirmPassword')}
            error={hasError.confirmPasswordError}
            helperText={hasError.confirmPasswordError ? t(hasError.confirmPasswordHelper) : ''}
            value={updatePassword.confirmPassword}
            onChange={handleChange}
            type="password"
            name="confirmPassword"
            required
          />
          <Button fullWidth type="submit" value="submit" variant="contained">{t('UserProfile.submit')}</Button>
        </form>
      </div>
    </Card>
  );
}

export default UserEditPassword;
